import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Modal from './Modal';
import HowItWorks from './HowItWorks';

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 0.8; }
`;

const HeaderContainer = styled.header`
  text-align: center;
  padding: 40px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  margin-bottom: 40px;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
    animation: ${pulse} 4s ease-in-out infinite;
  }
  
  @media (max-width: 768px) {
    padding: 30px 0;
  }
`;

const Title = styled.h1`
  font-size: 2.5em;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
  
  @media (max-width: 768px) {
    font-size: 2em;
  }
`;

const Subtitle = styled.p`
  font-size: 1.2em;
  opacity: 0.9;
  position: relative;
  z-index: 1;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 1em;
  }
`;

const HowItWorksButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  color: white;
  padding: 8px 20px;
  font-size: 0.9em;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  z-index: 1;
  position: relative;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

const Header = () => {
  const [modalOpen, setModalOpen] = useState(false);
  
  return (
    <>
      <HeaderContainer>
        <Title>🛡️ Cloud Security Configuration Checker</Title>
        <Subtitle>2026 DIY Assessment Tool — AWS · Azure · GCP · Multi-Cloud</Subtitle>
        <HowItWorksButton onClick={() => setModalOpen(true)}>
          <span>ℹ️</span> How it works
        </HowItWorksButton>
      </HeaderContainer>
      
      <Modal 
        isOpen={modalOpen} 
        onClose={() => setModalOpen(false)}
        title="How It Works"
        icon="🔍"
      >
        <HowItWorks />
      </Modal>
    </>
  );
};

export default Header; 